import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './controller/App';
import App404 from './controller/App404';

const USE_APP = process.env?.REACT_APP_BUILD?.replace(/ /g, '');

if (!document.querySelector('#root')?.childNodes?.length) {
    switch (USE_APP) {
        case '404':
        case 404:
            ReactDOM.render(
                <React.StrictMode>
                    <App404 />
                </React.StrictMode>,
                document.getElementById('root')
            );
            break;
        default:
            ReactDOM.render(
                <React.StrictMode>
                    <App />
                </React.StrictMode>,
                document.getElementById('root')
            );
    }
}
